export default "__VITE_ASSET__DFCH04Ih__"